import { gql } from '__generated__'

/**
 * Stores a marketing touch of the current user or guest session (FE-320).
 * The backend never overwrites the first touch; later ones become the last.
 */
export const CAPTURE_ATTRIBUTION = gql(`
  mutation captureAttribution($input: CaptureAttributionInput!) {
    captureAttribution(input: $input)
  }
`)
